<template>
  <div v-if="badgeText || imageBadge" class="ProductCard__Badges">
    <div v-if="badgeText" class="ProductCard__TextBadgeWrapper">
      <span
        data-ht-element="text-badge"
        class="ProductCard__TextBadge t5"
        v-html="badgeText"
      ></span>
    </div>
    <div v-if="imageBadge" class="ProductCard__ImgBadgeWrapper">
      <img
        data-ht-element="image-badge"
        class="ProductCard__ImgBadge"
        :class="loadedClass"
        :src="imageBadge"
        alt="Award"
        @load="transitionMedia"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';

const mediaLoaded = ref(false);
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  variant: {
    type: Object,
    required: false,
    default: () => ({}),
  },
});

const transitionMedia = () => (mediaLoaded.value = true);
const loadedClass = computed(() => {
  return mediaLoaded.value ? 'ProductCard__ImgBadge--Loaded' : '';
});

const variantBadging = computed(() => {
  const variant = props?.variant || {};
  return variant?.textBadge?.value || false;
});

const badgeText = computed(() => {
  // Check variant badge first — return early so product badge JSON is never
  // parsed unnecessarily. A malformed product badge value would otherwise throw
  // before the variant badge check, silently preventing the variant badge from showing.
  const hasVariantBadge = variantBadging.value;
  if (hasVariantBadge) {
    return variantBadging.value;
  }

  const text = props.item?.textBadge?.value ?? false;
  if (!text) return false;

  try {
    const parsed = JSON.parse(text)[0];
    return parsed !== 'false' && parsed !== '' ? parsed : false;
  } catch {
    return false;
  }
});

const imageBadge = computed(() => {
  const url = props.item?.imageBadge?.reference?.image?.url ?? false;
  if (!url || url === 'false') return false;
  return `${url}&transform=resize=250x250`;
});
</script>

<style lang="css" scoped>
.ProductCard__ImgBadge,
.ProductCard-ImageWrapper--Loaded .ProductCard__ImgBadge {
  opacity: 0;
  transition: opacity 200ms cubic-bezier(0, 0.55, 0.45, 1);
}

.ProductCard-ImageWrapper--Loaded .ProductCard__ImgBadge--Loaded {
  opacity: 1;
}
</style>
